import { ChevronDown, Moon, Sun } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { useTheme } from '@/app/ThemeProvider'

const languages = [
  { code: 'en', label: 'English', iconSrc: '/Uploads/eng.svg' },
  { code: 'fr', label: 'Français', iconSrc: '/Uploads/fr.svg' },
]

export function PublicPageControls({ className }: { className?: string }) {
  const { i18n } = useTranslation()
  const { resolvedTheme, setTheme } = useTheme()
  const currentLang = languages.find((language) => language.code === i18n.language) ?? languages[0]

  const handleLanguageChange = (code: string) => {
    i18n.changeLanguage(code)
  }

  const toggleTheme = () => {
    setTheme((current) => {
      const base = current === 'system' ? resolvedTheme : current
      return base === 'dark' ? 'light' : 'dark'
    })
  }

  return (
    <div className={`inline-flex items-center gap-1 ${className ?? ''}`}>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="sm" className="h-8 gap-1.5 px-2" aria-label={currentLang.label}>
            <img src={currentLang.iconSrc} alt="" className="h-4 w-4 object-contain" aria-hidden="true" />
            <ChevronDown className="h-3.5 w-3.5 text-muted-foreground" />
            <span className="sr-only">{currentLang.label}</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          {languages.map((language) => (
            <DropdownMenuItem
              key={language.code}
              onClick={() => handleLanguageChange(language.code)}
              className="cursor-pointer"
            >
              <img
                src={language.iconSrc}
                alt=""
                className="mr-2 h-4 w-4 object-contain"
                aria-hidden="true"
              />
              <span className={i18n.language === language.code ? 'font-semibold' : ''}>
                {language.label}
              </span>
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>

      <Button variant="ghost" size="icon" className="h-8 w-8" onClick={toggleTheme}>
        {resolvedTheme === 'dark' ? (
          <Sun className="h-4 w-4" />
        ) : (
          <Moon className="h-4 w-4" />
        )}
        <span className="sr-only">Toggle theme</span>
      </Button>
    </div>
  )
}
